import React from 'react';

import Style from './circle.module.scss';
interface CircleProps {
  circleData: {
    data: string | number; // Adjust this based on the structure of `circle0`, `circle1`, etc.
    borderColor: string;
    img: string;
    devices: number;
    countColor: string;
    label?: string;
  };
  onClick?: () => void;
}

const Circle: React.FC<CircleProps> = ({ circleData, onClick }) => {
  return (
    <>
      <div className={Style.device} onClick={onClick} style={{ cursor: onClick ? 'pointer' : 'default' }}>
        <div className={Style.eclipse} style={{ background: circleData.borderColor }}>
          <div className={Style.circle}> {circleData.data}%</div>
        </div>
        {/* <img src={circleData.img} alt="Circle" /> */}
        <div className="flex flex-col items-center justify-center mt-2">
          {circleData.img && <img className={Style.img} src={circleData.img} alt="Circle" />}
          {circleData.devices !== null && circleData.devices !== undefined && (
            <span
              className={`font-semibold  mt-4 ${Style.device_count}`}
              style={{ color: circleData.countColor }}
            >{`${circleData.devices} Devices`}</span>
          )}
          {circleData.label && (
            <span
              className={`mt-4`}
              //style={{ color: circleData.countColor }}
            >{`${circleData.label} `}</span>
          )}
        </div>
      </div>
    </>
  );
};

export default Circle;
